'use client';
export const dynamic = 'force-dynamic';
import { BaseComp } from 'components';
import Error404Comp from 'aloEjare/404/404.index';
import { __MetaTags } from './_lib/metatags';
export const metadata = __MetaTags({ title: 'تیک سبز | صفحه مورد نظر یافت نشد' });

export default function NotFound() {
    return (
        <BaseComp showHeaderInMobile>
            <Error404Comp />
        </BaseComp>
    );
}
